import apiClient from '@utils/apiClient';

export const projectList = (payload) => {
  return apiClient.post(`${apiClient.Urls.projectList}`, payload, true);
};


export const fetchQuarterly = (payload) => {
    return apiClient.post(`${apiClient.Urls.fetchQuarterly}`, payload, true);
  };

  export const calculateQuarterly = (payload) => {
    return apiClient.post(`${apiClient.Urls.calculateQuarterly}`, payload, true);
  };

  export const submitQuarterly = (payload) => {
    return apiClient.post(`${apiClient.Urls.submitQuarterly}`, payload, true);
  };

  export const quarterlyView = (payload) => {
    return apiClient.post(`${apiClient.Urls.quarterlyView}`, payload, true);
  };

  export const viewProject = (projectCode) => {
    return apiClient.get(`${apiClient.Urls.viewProject}/${projectCode}`, null, true);
  };
  

  export const projectListManager = (payload) => {
    return apiClient.get(`${apiClient.Urls.projectListManager}`, payload, true);
  };

  export const estimate = (params) => {
    const queryString = Object.keys(params)
      .map((key) => {
        // Check if the key is 'quarter' and only wrap it in quotes
        const value = key === 'quarter' ? `"${params[key]}"` : params[key];
        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      })
      .join('&');
    
    return apiClient.get(`${apiClient.Urls.estimate}?${queryString}`, true);
  };

  export const financialYear = (payload) => {
    return apiClient.get(`${apiClient.Urls.financialYear}`, payload, true);
  };


  export const quarter = (params) => {
    const queryString = Object.keys(params)
      .map(
        (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`,
      )
      .join('&');
    return apiClient.get(`${apiClient.Urls.quarter}?${queryString}`, true);
  };

  export const quarterManager = (params) => {
    const queryString = Object.keys(params)
      .map(
        (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`,
      )
      .join('&');
    return apiClient.get(`${apiClient.Urls.quarterManager}?${queryString}`, true);
  };

  
  